const ConvenienceSubContentListBox = () => {
	const images = {
		mimDesc: require('@/assets/images/sub/img_function_bg_mim_desc.jpg'),
		account: require('@/assets/images/sub/img_function_bg_account.png'),
		accountDesc: require('@/assets/images/sub/img_function_bg_account_detail.jpg')
	};

	const detailImg = {
		pharosAI1: require('@/assets/images/sub/img_function_bg_pharosAI_detail1.png'),
		pharosAI2: require('@/assets/images/sub/img_function_bg_pharosAI_detail2.png'),
		receiptocr1: require('@/assets/images/sub/img_function_bg_receiptocr_detail1.png'),
		receiptocr2: require('@/assets/images/sub/img_function_bg_receiptocr_detail2.png')
	};

	return (
		<ul>
			{/* 어카운팅 인사이트 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-desc">
					<img src={images.accountDesc} alt="어카운팅 인사이트" />
				</div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">실시간 질의/응답 제공</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">주요 회계기준서를 근거로 사용자의 질문에 대해 실시간으로 답변을 제공합니다.</li>
								<li className="bullet">
									회계기준서와 관련된 궁금한 내용을 바로 확인할 수 있어 검토 시간을 줄이고 업무 효율을 높일 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">관련 문서 검색 기능</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">AI는 답변과 함께 질문과 관련된 회계기준서 및 문서를 함께 찾아 제공합니다.</li>
								<li className="bullet">
									답변과 연관된 자료를 함께 확인할 수 있어 추가적인 검토도 한 번에 진행할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">최신 기준 반영</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									최신 회계기준서를 반영한 데이터를 기반으로 항상 최신 기준에 맞는 답변을 제공합니다.
								</li>
								<li className="bullet">지속적인 데이터 업데이트를 통해 정확도와 신뢰도를 지속적으로 높여갑니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">보안이 적용된 AI 환경</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									삼일 PwC 전용으로 구축된 AI 환경을 기반으로 내부 자료와 고객 정보를 보호할 수 있도록 설계되었습니다.
								</li>
								<li className="bullet">
									민감한 회계 데이터까지 고려한 보안 환경에서 보다 안심하고 활용할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 말만해 AI */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-item">
						<img src={detailImg.pharosAI1} alt="말만해AI, 챗봇형 전표 자동생성" />
						<div className="function-text">
							<strong className="title">챗봇형 전표 입력</strong>
							<div className="intro-desc">
								<ul className="bullet-square">
									<li className="bullet">
										전표 작성 시 거래 내용을 일상적인 문장 형태로 입력하면 AI가 입력된 텍스트를 분석하여 전표 생성을
										시작합니다.
									</li>
									<li className="bullet">
										복잡한 입력 항목을 하나씩 작성하지 않아도 대화형 입력만으로 전표 작성이 가능해 전표 입력 과정이
										간소화됩니다.
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">챗봇형 전표 작성 방식</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									LLM 기반 자연어 처리 기술을 활용한 챗봇 방식으로 전표 작성을 대화 흐름에 맞춰 처리할 수 있습니다.
								</li>
								<li className="bullet">
									기존의 항목별 입력 방식이 아닌 업무 맥락 중심의 입력 방식으로 전표 작성 업무 흐름을 보다 단순하게
									만듭니다.
								</li>
							</ul>
							<div className="ex-box">
								<p className="tit">입력 예시)</p>
								<p className="font-bold">‘12월 11일에 팀원들과 회식하고 20만원이 나왔는데 카드 결제했어”</p>
								<p>→ 입력 내용 분석</p>
								<p>→ 전표 자동 생성</p>
								<p>→ 계정과목 및 거래 정보 자동 반영</p>
							</div>
						</div>
					</div>
					<div className="function-item">
						<div className="function-text">
							<strong className="title">전표 자동 생성</strong>
							<div className="intro-desc">
								<ul className="bullet-square">
									<li className="bullet">
										입력된 거래 문장을 기반으로 AI가 거래일자와 금액, 거래 성격을 분석하여 전표 정보를 자동으로
										생성합니다.
									</li>
									<li className="bullet">
										전표 작성에 필요한 주요 정보가 자동으로 구성되어 수기 입력에 따른 오류와 반복 작업을 줄일 수
										있습니다.
									</li>
								</ul>
							</div>
						</div>
						<img src={detailImg.pharosAI2} alt="말만해AI, 챗봇형 전표 자동생성" />
					</div>
					<div className="function-text">
						<strong className="title">전표 정보 자동 반영</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									AI는 입력된 거래 내용을 분석하여 거래일자와 거래적요, 금액, 계정과목, 거래처명 등 전표 처리에 필요한
									정보를 자동으로 반영합니다.
								</li>
								<li className="bullet">
									자동 생성된 정보는 사용자가 직접 확인하고 수정할 수 있어 정확성을 유지한 상태로 전표를 완성할 수
									있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className="function-notice">
					<p>* 베타 서비스 안내</p>
					<p className="font14-400">
						말만해 AI는 현재 베타(Beta) 버전으로 제공되는 기능으로, 실제 사용 데이터를 기반으로 정확도 및 사용성 개선을
						목적으로 운영됩니다.
					</p>
				</div>
			</li>
			{/* 영수증 업로드 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-item">
						<img src={detailImg.receiptocr1} alt="영수증 이미지 분석" />
						<div className="function-text">
							<strong className="title">영수증 이미지 업로드</strong>
							<div className="intro-desc">
								<ul className="bullet-square">
									<li className="bullet">
										전자적으로 거래 수집이 어려웠던 외부 결제, 개인카드 사용, 간이영수증, 종이 영수증 등도 영수증 이미지
										파일을 업로드하는 방식으로 거래 증빙을 등록할 수 있습니다.
									</li>
									<li className="bullet">
										그동안 영수증을 직접 확인하며 수기로 전표를 입력해야 했던 과정을 이미지 업로드 기반 처리로 전환하여
										반복적인 입력 업무 부담을 줄여줍니다.
									</li>
								</ul>
							</div>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">거래 정보 자동 인식</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									업로드된 영수증 이미지를 AI 기반 OCR 기술로 분석하여 거래일자와 사용처, 금액, 적요, 결제수단 등 전표
									처리에 필요한 주요 거래 정보를 자동으로 인식합니다.
								</li>
								<li className="bullet">
									인식된 정보는 구조화된 데이터로 변환되어 이후 전표 생성 및 회계 처리에 활용할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-item">
						<div className="function-text">
							<strong className="title">전표 정보 생성 및 계정과목 추천</strong>
							<div className="intro-desc">
								<ul className="bullet-square">
									<li className="bullet">
										영수증에 포함된 거래 내용과 사용처 정보를 기준으로 전표 작성에 필요한 정보를 자동으로 구성하고, 거래
										성격에 맞는 계정과목을 추천합니다.
									</li>
									<li className="bullet">
										자동 생성된 결과는 사용자가 직접 확인하고 필요한 항목을 보완한 후 저장할 수 있어 입력 오류와 누락을
										줄이고 전표 처리의 정확도를 높일 수 있습니다.
									</li>
								</ul>
							</div>
						</div>
						<img src={detailImg.receiptocr2} alt="자동분개 및 전표처리" />
					</div>
					<div className="function-text">
						<strong className="title">전표 연동 및 거래 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									저장된 영수증 거래 내역은 목록 형태로 관리할 수 있으며, 전표 발행을 통해 회계 처리로 연동할 수
									있습니다.
								</li>
								<li className="bullet">
									수기로 관리되던 영수증 증빙을 전자 데이터로 전환함으로써 매입 관리 효율을 높이고, 감사 및 세무조사
									대응 시에도 증빙 자료로 즉시 활용할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
				<div className="function-notice">
					<p>* 베타 서비스 안내</p>
					<p className="font14-400">
						영수증 업로드는 현재 베타(Beta) 버전으로 제공되는 기능으로, 실제 사용 데이터를 기반으로 정확도와 사용성
						개선을 목적으로 운영됩니다.
					</p>
				</div>
			</li>
			{/* 고정자산관리 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">취득전표 연동</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">차변 자산계정 라인을 전표 입력 시 실시간으로 감지합니다.</li>
								<li className="bullet">
									신규취득 · 자본적지출 여부를 사용자가 직접 선택할 수 있도록 등록 팝업을 제공합니다.
								</li>
								<li className="bullet">
									본체 취득전표와 설치비 등 자본적지출 전표를 하나의 자산에 함께 연결할 수 있습니다.
								</li>
								<li className="bullet">
									전표 입력 시점의 계정과목·거래처·적요 정보를 그대로 가져와 등록 화면의 입력 항목을 자동으로 채우므로,
									담당자는 내용을 확인만 하면 됩니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">연결전표 조회</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">자산 화면에서 이 자산을 구성한 전표를 전부 조회할 수 있습니다.</li>
								<li className="bullet">합계 금액이 취득가액과 자동으로 일치하는지 검증선을 표시합니다.</li>
								<li className="bullet">
									한 번 연결된 전표-자산 매핑은 임의로 삭제할 수 없도록 설계돼 취득 이력이 사후에 지워지거나 조작될
									위험이 없습니다 — 감사 대응력과 내부통제를 함께 강화합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">매각/폐기 자동분개</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									자산코드를 선택하면 취득원가와 감가상각누계액, 장부가액을 자동으로 조회합니다.
								</li>
								<li className="bullet">
									매각금액을 입력하는 즉시 장부가액과 비교해 처분손익을 계산하고, 손실이 나면 차변·대변을 자동으로
									전환해 처분손실로 처리합니다.
								</li>
								<li className="bullet">
									감가상각누계액은 차변으로, 취득원가(자산계정)는 대변으로 자동 상계 처리되어 자산이 장부에서 정확히
									제거됩니다.
								</li>
								<li className="bullet">
									자산 종류에 따라 서로 다른 감가상각누계액 계정(예: 기계장치 20600 ↔ 20700, 비품 21200 ↔ 21300)까지
									자동으로 매칭해 분개에 채워 넣습니다.
								</li>
								<li className="bullet">
									부가세와 미수금까지 포함한 분개를 자동으로 생성해, 담당자는 확인 후 저장만 하면 됩니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">부분처분 계산</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									처분수량을 입력하면 최초 취득 수량이 아니라 그 시점의 잔존 취득원가·잔존 수량을 기준으로 다시
									계산합니다.
								</li>
								<li className="bullet">
									감가상각누계액도 처분비율만큼 자동으로 안분해 상계 처리하므로, 두 번째·세 번째 부분처분에서도 과거
									처분 이력이 이중으로 반영되지 않습니다.
								</li>
								<li className="bullet">
									처분비율만큼 취득원가와 감가상각누계액을 함께 덜어내 잔존 자산의 장부금액이 항상 정확하게 맞습니다.
								</li>
								<li className="bullet">
									잔여 수량은 '진행' 상태로 자동 유지되어 다음 처분에도 그대로 이어지고, 전량 처분되면 자동으로
									'처분완료' 상태로 전환됩니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 즐겨찾기 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">전체메뉴</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									파로스 ERP를 통해 사용할 수 있는 전체 메뉴를 한눈에 확인할 수 있으며, 조회권한이 있는 메뉴는 클릭하여
									해당 메뉴로 바로갈 수 있습니다.
									<br />
									<br />
									<p className="color-primary">
										* 단, 조회 권한이 없는 메뉴는 비활성화 처리되어 메뉴 이동이 불가능합니다.
									</p>
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">즐겨찾기</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									자주 사용하는 메뉴의 바로가기를 지원하는 파로스 ERP만의 개인화 즐겨찾기 기능입니다.
								</li>
								<li className="bullet">활성화 버튼을 통해 즐겨찾기를 최대 25개까지 설정할 수 있습니다.</li>
								<li className="bullet">
									사용하지 않으실 경우는 즐겨찾기 편집을 통해 사용 여부를 비활성화처리해 주세요.
								</li>
								<li className="bullet">
									즐겨찾기 기능을 활성화하면 자주 사용하는 메뉴 조합으로 즐겨찾기에 추가되어 편리하게 이용 가능합니다.
								</li>
								<li className="bullet">
									사용 여부, 즐겨찾기 설정, 순서 변경에 수정사항이 있을 경우, 반드시 저장 버튼을 눌러주세요.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 대시보드 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">매출/매입 정보</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									로그인 후 메인 메뉴에서 확인할 수 있으며, 월별 매출매입 및 매출 이익 현황이 조회됩니다.
								</li>
								<li className="bullet">
									세금계산서, 신용카드, 현금영수증 등 증빙별 매출매입 현황 및 외상 매출매입 거래처 Top5를 파악할 수
									있습니다.
								</li>
								<li className="bullet">
									매일 업데이트되는 챠트 및 시각데이터를 통해 편리하게 자금 흐름을 파악하고, 경영관리를 위한 인사이트를
									제공받을 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">계좌현황</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									[금융관리]-[계좌현황] 메뉴에서 확인할 수 있으며, [기초정보]-[외부기관연동]에서 연동 수집된 계좌의 잔액
									및 예적금/대출/펀드/외화 등 계좌별 현황을 한 눈에 파악할 수 있습니다.
								</li>
								<li className="bullet">
									계좌 현황에서도 즉시 계좌 연동이 가능하며, 수집된 자료 기준 계좌의 연동 개수, 현 잔액과 총액 대비
									비율의 정보 등 자산 대비 비율을 제공합니다.
								</li>
								<li className="bullet">
									계좌의 형태에 따라 입출금 잔액 현황(상세), 예적금 계좌 현황, 대출 계좌 현황, 외화 잔액 현황 등의 상세
									데이터를 조회해 주며, 대출계좌의 경우 원금과 이율 등을 표기하고, 외화 계좌의 경우 통화 코드별 외화
									잔액과 원화로 환산된 금액을 표기하여 자금 관리에 매우 유효한 정보를 제공합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">입출금계좌</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									[금융관리]-[입출금계좌] 메뉴에서 확인할 수 있으며, [기초정보]-[외부기관연동]에서 연동한 모든 계좌의
									목록과 잔액이 조회됩니다.
								</li>
								<li className="bullet">
									전월대비 입/출금 통계 및 계좌 입출금 현황, 월간 입출금 Top5 거래처 등을 한 눈에 확인할 수 있어서 계좌
									흐름을 쉽게 파악할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">카드 정보</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									[금융관리]-[카드] 메뉴에서 확인할 수 있으며, [기초정보]-[외부기관연동]에서 연동한 모든 카드사의 자료를
									기준으로 조회됩니다.
								</li>
								<li className="bullet">
									월 누적 금액 일별 카드 사용현황, 월 청구금액 및 카드 사용추이 등을 한 눈에 확인할 수 있어서 카드
									사용내역을 쉽게 파악할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">기타 대시보드</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									금융관리, 인사/급여, 재고관리 메뉴에서도 각 개별 대시보드를 시각화된 데이터로 제공합니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 신용정보 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">나이스 평가정보 제휴(업계 최초! 국내 유일!)</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">40년 이력의 국내 최대 개인 및 기업 신용정보 데이터베이스 보유</li>
								<li className="bullet">기업 개요, 재무∙비재무 정보, 대안정보, 각종 신용등급 및 평가 데이터 제공</li>
								<li className="bullet">
									업계 최초! 국내유일! 오직 스텔라 고객만을 위한 자사 및 거래처 신용정보 관리 기능 제공
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">기본 신용 정보 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">거래처 신용등급을 22단계 구간으로 나누어 제공합니다.</li>
								<li className="bullet">
									AAA+ ~ D 등급까지의 신용등급 제공을 통해 거래처의 안정성에 대한 평가가 가능합니다.
								</li>
								<li className="bullet">
									상세매출, 자산, 부채, 자본, 세전이익, 부채비율, 세전이익률 등 최신 주요 재무정보를 제공합니다.
								</li>
								<li className="bullet">
									최근 신용등급 변동일자, 변동 단계를 제공해드리며 조회된 거래처 일반개요 정보를 스텔라 거래처정보로
									업데이트 할 수 있습니다.
								</li>
								<li className="bullet">
									[기초정보]-[정보관리]-[거래처정보] 메뉴에서 거래처 신용등급에 대한 정보를 확인하실 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 프로젝트 관리 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">프로젝트/현장정보 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									프로젝트와 현장은 탭으로 구분되어 등록 가능하며, 각 프로젝트 또는 현장별로 거래를 입력하여 해당 건 별
									총 매출액과 사용된 비용 등을 따로 산출해 볼 수 있습니다.
								</li>
								<li className="bullet">
									신규등록과 수정, 삭제가 가능하며 등록된 프로젝트 및 현장 리스트를 다운로드하여 관리할 수 있습니다.
								</li>
								<li className="bullet">
									수집된 거래내역에 부서, 사원정보 뿐 아니라 프로젝트 및 현장 정보를 입력하여 전표 연동 발행 가능
								</li>
								<li className="bullet">
									[회계관리]-[경영보고서]에서 프로젝트별/현장별 손익보고서를 바로 확인 가능하며, 수익과 비용을
									세부적으로 분석하는 데 활용할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 기업뱅킹 연동 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">금융사 직접 연동</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									금융사별 기업인터넷뱅킹 가입 후 가입은행에서 사용한 공인인증서 연동 후 스텔라 플랫폼 연동하면
									이체기능을 바로 사용할 수 있습니다.
								</li>
								<li className="bullet">
									금융사별 제공하는 이체건수보다 스텔라플랫폼을 이용하면 더 많은 이체가 가능하도록 혜택을 드립니다.
								</li>
								<li className="bullet">
									주 이용 금융사 직접연동으로 더욱 빠르고 간편하게 각종 이체서비스를 이용할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 원천세 신고 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">원천세 신고</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									원천세는 모든 원천징수 소득(근로/사업/기타/퇴직)에 대해 부과되는 소득세(국세)와 지방소득세(지방세)를
									의미하며, 해당 소득자의 원천세를 사업자가 지급액에서 먼저 제한 후 국가에 대신 납부하는 제도를
									말합니다.
								</li>
								<li className="bullet">
									급여를 지급하는 근로자가 있는 기업은 급여 지급일이 속하는 달의 다음달 10일까지 원천세신고 및 납부를
									해야 합니다.
								</li>
								<li className="bullet">
									[세금신고]-[원천세신고] 메뉴에서 이용할 수 있으며, 귀속년월과 지급년월 기준 급여자료에 등록된 각
									소득구분별로 자료가 자동으로 반영되므로 원천세신고 자료인 원천징수이행상황신고서와 간이지급명세서를
									간편하게 작성할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 부가세 신고 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">부가세 신고서 생성</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">매입매출전표 증빙유형 및 계정과목에 기반하여 부가세 신고서를 생성합니다.</li>
								<li className="bullet">
									예정/확정 신고, 영세율 조기환급, 기한 후 신고 등 다양한 신고 기능을 제공합니다.
								</li>
								<li className="bullet">
									사용자가 직접 작성해야 할 첨부서류는 작성 서식을 제공하여 편리하게 작업이 가능합니다.
								</li>
								<li className="bullet">작성내용 저장, 신고서 마감 기능을 통해 자료변환을 방지합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">주요서류 지원 목록</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">부가가치세신고서(일반과세자 신고서 및 수정신고서)</li>
								<li className="bullet">사업장현황명세서, 부가가치세 납부서</li>
								<li className="bullet">
									매출세금계산서합계표, 매입세금계산서합계표, 매출계산서합계표, 매입계산서합계표, 신용카드매출전표등
									수령명세서, 신용카드매출전표발행금액집계표
								</li>
								<li className="bullet">
									공제받지못할 매입세액명세서, 건물등감가상각자산취득명세서,대손세액공제(변제)신고서 전자세금계산서
									발급세액공제신고서, 과표수정 및 추가납부계산서, 과표 및 세액경정청구서
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">업종별 첨부 서류 지원 목록</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									매입자발행세금계산서합계표, 매입자발행계산서합계표, 부동산임대공급가액명세서, 의제매입세액공제신고서,
									재활용폐자원세액공제신고서, 현금매출명세서, 전자화폐결제명세서, 수출실적명세서,
									영세율첨부서류제출명세서, 영세율매출명세서, 내국신용장/구매확인서, 외화획득명세서
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 세금 계산서 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">세금계산서 발행</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									일반/영세/면세 등 모든 과세 유형별 세금계산서를 발행할 수 있습니다. 발행한 세금계산서는 즉시발송 혹은
									익일 전송으로 선택이 가능하며, 익일 전송으로 발행된 세금계산서는 전송 전(발행당일)에 한하여 발행취소가
									가능합니다.
								</li>
								<li className="bullet">
									전자 발행한 세금계산서가 홈택스로 전송 완료되면 [홈택스 전송 후]탭에서 조회되며, 즉시전송으로 발행 한
									세금계산서는 즉시 홈택스로 전송되어 발행 취소는 불가 하며, 전송 완료 처리 후 수정 발행만 가능 합니다.
								</li>
								<li className="bullet">이메일로 자동발행되며 발행 내역의 출력이 가능합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">거래명세서 발행</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									거래명세서 발행 시에는 [기초정보]에서 등록한 [품목정보] 를 불러오기 할 수 있으며, 항목을 직접 추가 및
									삭제가 가능하며, 작성한 거래명세서로 세금계산서 발행도 가능합니다.
								</li>
								<li className="bullet">이메일/문자/팩스로 전자발행되며 출력이 가능합니다.</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 모바일 재고관리 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-desc">
					<img src={images.mimDesc} alt="mim" />
				</div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">실시간 재고현황 확인</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">제품 정보, 잔여재고량 등 재고현황을 실시간으로 조회</li>
								<li className="bullet">언제 어디서나 모바일로 재고 상태 확인 가능</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">정확한 입·출고 내역 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">품목별 / 거래처별 / 창고별 입출고 내역 관리</li>
								<li className="bullet">ERP와 연동된 데이터로 정확한 기록 유지</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">간편한 재고조정 & 창고 이동</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">증감 처리 등 재고조정 기능 제공</li>
								<li className="bullet">창고별 재고량 조회 및 창고 간 재고 이동 가능</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">손쉬운 QR코드 & 바코드 스캔</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">카메라로 QR·바코드 스캔하여 제품등록</li>
								<li className="bullet">모바일 스캔 기능 + 제품 이미지 등록 지원</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">편리한 바코드 라벨 인쇄</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">필요한 제품을 선택해 모바일에서 바로 바코드 라벨 인쇄</li>
								<li className="bullet">재고관리 과정의 번거로운 인쇄 작업 간소화</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 보고서 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list">
					<div className="function-text">
						<strong className="title">월간결산보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">월간결산보고서는 [경영보고서] 메뉴에서 확인 가능 합니다.</li>
								<li className="bullet">
									주요 재무 지표와 매출·자금 흐름 데이터를 대시보드 형태로 제공하여 월별 경영 성과를 직관적으로 파악할
									수 있도록 지원합니다.
								</li>
								<li className="bullet">
									당월 기준 현금 잔액과 외상매출·외상매입, 영업이익 등 핵심 재무 지표를 상단에 요약해 제공하며, 전월
									대비 증감 정보도 함께 확인할 수 있습니다.
								</li>
								<li className="bullet">
									월간 자금 수지 내역과 손익 추이를 시각화하여 기간별 실적 변화와 누적 흐름을 한 화면에서 분석할 수
									있고, 당월 매출과 누적 연간 매출 현황을 함께 제공해 월별 실적과 연간 성과를 종합적으로 관리할 수
									있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">보고서는 [회계관리] 메뉴에서 확인 가능합니다.</li>
								<li className="bullet">
									미수금 및 미지급금 현황에 대해 거래처별 별로 확인할 수 있으며 기간 설정 시 해당기간의 잔액을 자동
									계산하여 제공하고 있습니다.
								</li>
								<li className="bullet">
									기간별 영업이익, 매출액 및 매입액을 파악할수 있도록 기간손익보고서를 제공하고 있습니다.
								</li>
								<li className="bullet">
									프로젝트별, 현장별, 부서별 손익보고서도 자동으로 생성되며, 다운로드 가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">금융보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">입력된 전표 기준으로 전일잔액과 당일 증감에 대한 현황을 확인할 수 있습니다.</li>
								<li className="bullet">
									자금일보를 통해 현금 등의 자금 흐름을 정확하게 파악함으로써 금융위험을 효과적으로 관리할 수 있으며,
									투명성을 강화하고 회계 감사 시 필요한 정보를 제공합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">급여보고서</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">급여보고서는 [인사/급여] 메뉴에서 확인 가능합니다.</li>
								<li className="bullet">
									연간 급여집계 및 지급 항목별 집계, 공제항목별 집계 등 사원별 세부적인 급여관리가 가능합니다.
								</li>
								<li className="bullet">
									지급 항목은 급여업무설정에 등록되어 있는 항목을 기준으로 급여가 등록된 이력이 있는 항목에 대해
									사원별로 지급된 금액을 세부적으로 확인할 수 있습니다.
								</li>
								<li className="bullet">
									공제 항목은 급여업무설정에 등록되어 있는 항목을 기준으로 공제된 내역에 대해 확인할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 기간비용 & 기간수익 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list cost">
					<div className="function-text">
						<strong className="title">기간비용</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									사업을 하다 보면 보험료, 임대료, 공사비처럼 한 번에 결제하지만, 실제로는 여러 달에 걸쳐 사용되는
									비용들이 있습니다. <br />
									이런 비용은 회계상 한 번에 전액 비용처리하지 않고, 기간에 맞게 나눠 인식해야 합니다. <br />
									이를 ‘선급비용의 상각’이라고 하며 스텔라의 ‘기간비용’ 기능은 이 과정을 정확하고 편리하게 도와드립니다.
									<p className="bullet-title">예시)</p>
									<ul className="bullet-dot">
										<li className="bullet">보험료를 연 단위로 결제했지만, 매달 일정액만 비용으로 처리하고 싶은 경우</li>
										<li className="bullet">임대료를 선불로 지급했지만, 사용 기간에 맞춰 비용 인식이 필요한 경우</li>
										<li className="bullet">
											공사비, 유지보수비 등 장기 계약에 따른 선급비용을 분할하여 처리하고 싶은 경우
										</li>
									</ul>
									<ul className="bullet-num">
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>① 자동 상각표 제공</span>
												</p>
												→ 선급비용을 기간에 따라 나누어 매달 얼마씩 비용으로 인식해야 할지 미리 확인할 수 있습니다.
											</div>
										</li>
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>② 정확한 전표 자동 생성</span>
												</p>
												→ 상각 일정에 맞춰 매달 전표를 자동으로 생성해, 누락 없이 회계처리할 수 있습니다.
											</div>
										</li>
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>③ 다양한 항목에 적용 가능</span>
												</p>
												→ 보험료뿐만 아니라, 임대료·공사비 등 모든 선급비용 항목에 적용할 수 있습니다.
											</div>
										</li>
									</ul>
									정확한 회계처리로 세무 리스크를 줄이고, 복잡한 비용 인식도 간편하게 해결하세요. ‘기간비용’ 기능으로 더
									스마트한 회계 관리, 지금 바로 경험해보세요
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">기간수익</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									서비스 요금을 한 번에 청구하거나 수령했더라도, 실제 제공 기간에 맞춰 수익을 나눠서 인식해야 하는
									경우가 있습니다. 이럴 때 필요한 것이 바로 ‘기간수익’ 기능입니다.
									<br />
									회계상 이를 선수수익의 인식이라고 하며, 스텔라는 이 복잡한 과정을 자동 계산 + 전표 처리로 간편하게
									해결해드립니다.
									<p className="bullet-title">예시)</p>
									<ul className="bullet-dot">
										<li className="bullet">
											연간 이용권이나 SaaS 요금을 미리 청구했지만, 매달 서비스 제공에 따라 수익을 나눠 인식해야 하는
											경우
										</li>
										<li className="bullet">
											프로젝트 계약금을 먼저 받았지만, 실제로는 진행 기간에 따라 수익을 분할 인식해야 하는 경우
										</li>
										<li className="bullet">
											임대료 등 선불로 받은 수익을 계약 기간에 맞춰 수익으로 인식해야 하는 경우
										</li>
										<li className="bullet">
											장기 유지보수/서비스 계약 등, 계약 기간 중 지속적으로 제공하는 서비스의 수익 인식
										</li>
									</ul>
									<ul className="bullet-num">
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>① 수익 분할 계산 자동화</span>
												</p>
												→ 설정한 제공 기간에 따라 매월 인식해야 할 수익 금액을 자동 계산합니다.
											</div>
										</li>
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>② 정확한 수익 전표 자동 생성</span>
												</p>
												→ 매달 인식해야 할 금액만큼 자동으로 전표를 생성하여, 회계 누락 없이 관리할 수 있어요.
											</div>
										</li>
										<li className="bullet">
											<div>
												<p className="font-bold">
													<span>③ SaaS, 임대, 프로젝트 등 다양한 업종에 적용 가능</span>
												</p>
												→ 반복 수익, 고정 수익, 계약 기반 수익 등 어떤 형태의 매출에도 유연하게 대응합니다.
											</div>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 반제관리 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list community">
					<div className="function-text">
						<strong className="title">
							통장 입∙출금 내역과 연계한 <br />
							반제전표 생성
						</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">실제 입출금 내역과 연결하여, 손쉽게 반제 전표를 생성할 수 있습니다.</li>
								<li className="bullet">
									전표 생성 시 거래처별 반제 잔액을 확인하고, 반제할 거래를 선택해 처리할 수 있습니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">
							다양한 반제 방식 지원 <br />
							(전액, 부분, 초과 반제)
						</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">전액반제, 부분반제, 초과반제를 모두 지원합니다.</li>
								<li className="bullet">반제처리 시 자동분개가 기본 제공되어 수작업 부담을 줄여줍니다.</li>
								<li className="bullet">반제를 원하지 않는 기준전표는 반제 제외 설정도 가능합니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">과거 거래건 반제 관리</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									올해 거래뿐만 아니라 과거 발생한 미반제 건도 리스트로 확인하고 관리할 수 있습니다.
								</li>
								<li className="bullet">남아있는 잔액을 놓치지 않고 체계적으로 관리하세요.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">반제 현황 페이지 제공</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">거래처별∙계정과목별 기준전표와 반제전표를 한눈에 볼 수 있습니다.</li>
								<li className="bullet">반제전표를 직접 입력하여 추가 반제도 간편하게 처리할 수 있습니다.</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">
							AR(매출채권) 만기일 관리 및 <br />
							채권연령 보고서 제공
						</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">채권 발생일 및 만기일을 기준으로 채권연령을 분석할 수 있습니다.</li>
								<li className="bullet">
									만기일 기준 또는 거래일자 기준으로 남은 채권을 상세히 파악할 수 있어, 보다 정확한 회수계획 수립이
									가능합니다.
								</li>
							</ul>
						</div>
					</div>
					<div className="function-text">
						<strong className="title">AP(매입채무) 잔액 채권연령별 분석</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									매입채무에 대해서도 거래처별 잔액을 채권연령별로 구분하여 확인할 수 있습니다.
								</li>
								<li className="bullet">지급계획 수립과 현금흐름 관리를 더욱 체계적으로 지원합니다.</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
			{/* 세무대리인 소통함 */}
			<li className="sub-list">
				<div className="function-vod"></div>
				<div className="function-list community">
					<div className="function-text">
						<strong className="title">소통함</strong>
						<div className="intro-desc">
							<ul className="bullet-square">
								<li className="bullet">
									스텔라/파로스 내에서 세무대리인과 간편하게 질문을 주고받고, 요청 내용을 한눈에 확인할 수 있습니다.
								</li>
								<li className="bullet">
									하나의 요청에 대해 지속적으로 댓글을 통해 세무대리인과 내용을 주고받으며 세부 사항을 명확히 할 수
									있습니다.
								</li>
								<li className="bullet">
									각종 세무 자료나 필요한 서류를 간편하게 주고받을 수 있어 업무 효율이 향상됩니다.
								</li>
								<li className="bullet">
									새로운 문의나 답변이 등록되면 즉시 카카오톡으로 알림을 받아 빠르게 확인할 수 있습니다.
								</li>
							</ul>
							<ul className="bullet-star">
								<li className="bullet">단, 세무대리인이 COMPAS 서비스를 사용하는 경우에만 이용할 수 있습니다.</li>
							</ul>
						</div>
					</div>
				</div>
			</li>
		</ul>
	);
};

export default ConvenienceSubContentListBox;
